import React, { forwardRef, memo } from "react";

import "./selectedBar.scss";

export interface SelectedBarProps {
  children?: React.ReactNode;
}

const SelectedBarComponent = forwardRef<HTMLDivElement, SelectedBarProps>((props, ref) => {
  return (
    <div className="xgs-table__selected-bar">
      <div className="xgs-table__selected-bar__bar" ref={ref}>
        {props.children}
      </div>
    </div>
  );
});

SelectedBarComponent.displayName = "SelectedBar";

const SelectedBar = memo(SelectedBarComponent);

export default SelectedBar;
